// Copyright Epic Games, Inc. All Rights Reserved.

import { useEffect } from "react";

let listeners: CallableFunction[] = [];

// Check for dev purposes only. In prod this field always exists.
if (window.ue) {
  window.ue.ui.onClosing = () => {
    console.log("Windows is closing! Calling listeners for close events!");

    for (const listener of listeners) {
      listener();
    }
  };
}

export const useOnClose = (listener: CallableFunction): void => {
  useEffect(() => {
    listeners.push(listener);

    return () => {
      listeners = listeners.filter(
        (currentListener) => currentListener !== listener
      );
    };
  }, [listener]);
};
